import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import classnames from "classnames";
import { SportOffer, TournamentOffer } from "@gp/offer";
import { THEME_SETTINGS } from "@theme-settings";
import { useRootAppStore } from "@hooks";
import { analyticsTracker } from "@utils/analytics";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";

export const FavoritesIcon = !THEME_SETTINGS.features.isFavoritesEnabled
	? () => null
	: observer(function FavoritesIcon(props: {
			tournament: TournamentOffer;
			sport: SportOffer;
		}) {
			const [isHover, setIsHover] = useState(false);
			const favoriteStore = useContext(FavoritesStoreContext);
			const { t } = useTranslation();
			const rootStore = useRootAppStore();

			if (props.sport.isOutright) {
				return null;
			}
			const isFavorite = favoriteStore.userFavoriteTournamentsSet.has(
				props.tournament.id
			);

			const onButtonClick = () => {
				if (isFavorite) {
					favoriteStore.removeUserFavoriteTournament(
						props.tournament.id
					);
				} else {
					favoriteStore.addUserFavoriteTournament(
						props.tournament.id
					);
					analyticsTracker.trackTournamentFavorited(
						props.tournament.abrv,
						props.tournament.id,
						props.sport.abrv
					);
				}
			};

			const favIconClasses = classnames("u-icon u-icon--big", {
				"u-icon--favorite--bold u-color--sent--warning":
					isFavorite ||
					(!isFavorite &&
						isHover &&
						rootStore.userAuthStore.isLoggedIn),
				"u-icon--favorite--alt u-color--sent--muted":
					(!isFavorite && !isHover) ||
					!rootStore.userAuthStore.isLoggedIn,
				"is-disabled": !rootStore.userAuthStore.isLoggedIn,
			});

			const tooltipMessage = !rootStore.userAuthStore.isLoggedIn
				? t("FAVORITES.NONAUTH_TOOLTIP")
				: "";

			return (
				<button
					type="button"
					data-tooltip-id="tv-description"
					data-tooltip-content={tooltipMessage}
					data-tooltip-position-strategy="fixed"
					disabled={!rootStore.userAuthStore.isLoggedIn}
					onClick={onButtonClick}
					onMouseEnter={() => setIsHover(true)}
					onMouseLeave={() => setIsHover(false)}
					className="btn btn--square btn--square--reset btn--ghost u-mar--right--xsml"
					data-at="at-addTournamentToFavouritesBtn"
				>
					<i className={favIconClasses} />
				</button>
			);
		});
